import { useState } from 'react';
import debounce from 'lodash/debounce';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Main from '../../../../layouts/Main';
import {Alert, Box,Divider, FormControl, InputAdornment, Link, OutlinedInput, Stack, ToggleButton, ToggleButtonGroup, useMediaQuery, useTheme } from '@mui/material';
import { Search } from '@mui/icons-material';

import Container from '../../../../components/Container';
import PageBreadcrumbs from '../../../../components/PageBreadcrumbs';
import CommitteeList from './components/CommitteeList';
import ChangeOfPurposeList from './components/ChangeOfPurposeList';

const RecentlyOrganized = (): JSX.Element => {
    
    document.title = 'OCPF - Recently Organized';

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
         defaultMatches: true,
    });

    //default tab
    const filerTypes = ['Candidates', 'Change of Purpose', 'PACs', 'Ballot Questions', 'Segregated Accounts'];
    const [filerType, setFilerType] = useState('Candidates');
    const [officeName, setOfficeName] = useState('');

    const switchFilerType = (event: any, newType: string) => {
        if (newType !== null) {
            setFilerType(newType);
        }
      };

    const filterByOffice = debounce((event: any) => {
        const value = event.target.value.toLowerCase();
        setOfficeName(value);
    },1000)

   return (
    <Main>
      <Container>
        <PageBreadcrumbs></PageBreadcrumbs>
        <Typography
            variant="h5"
            align={'left'}
            sx={{
                fontWeight: 700,
            }}
            paddingTop={3}
            gutterBottom
            marginBottom={2}
            >
            Recently Organized Filers
        </Typography>
        <Stack sx={{ width: '100%' }} spacing={2}>
            <Alert severity="info">Follow <Link target="_blank" href="https://x.com/OCPFORG">OCPFORG</Link> on X for up-to-date announcements on newly organized candidates and political committees, as well as candidates who change their office sought.</Alert>
        </Stack>
        <Divider/>
        <Grid container marginTop={3}>
            <Grid size={12} display={'flex'} flexWrap={'wrap'}>
                <ToggleButtonGroup
                    exclusive
                    fullWidth = {isMd? false: true}
                    aria-label="filer types"
                    size="small"
                    color="primary"
                    value={filerType}
                    onChange={switchFilerType}
                >
                    {filerTypes.slice(0,3).map((type) => (
                        <ToggleButton 
                            key={type} 
                            value={type} 
                            aria-label={`filer data - ${type}`}
                            sx={{fontWeight:800, width: isMd? 200: "auto"}}
                        >
                            {type}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
                <ToggleButtonGroup
                     exclusive
                     fullWidth = {isMd? false: true}
                     aria-label="filer content types"
                     size="small"
                     color="primary"
                     value={filerType}
                     onChange={switchFilerType}
                >
                    {filerTypes.slice(3).map((type) => (
                        <ToggleButton key={type} value={type} aria-label={`filer data - ${type}`}
                            sx={{fontWeight:800, width: isMd? 200: "auto"}}
                        >
                            {type}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Grid>
            {
                filerType === 'Candidates' &&
                <Grid size={12} marginTop={3}>
                    <FormControl size="small" sx={{ maxWidth: 300 }} variant="outlined">
                        <OutlinedInput
                            placeholder={"Search Office Name..."}
                            aria-label='Search office name'
                            startAdornment={
                                <InputAdornment position="start">
                                  <Search />
                                </InputAdornment>
                            }
                            onChange={filterByOffice}
                            sx={{ fontSize: 'smaller' }}
                        />

                    </FormControl>
                </Grid>
            }
            <Grid size={12}>
                <Box>
                {
                    filerType === 'Change of Purpose' && <ChangeOfPurposeList></ChangeOfPurposeList>
                }
                {
                    filerType === 'Candidates' && <CommitteeList tpye={'C'} officeName={officeName}></CommitteeList>
                }
                {
                    filerType === 'PACs' && <CommitteeList tpye={'P'}></CommitteeList>
                }
                {
                    filerType === 'Ballot Questions' && <CommitteeList tpye={'B'}></CommitteeList>
                }
                {
                    filerType === 'Segregated Accounts' && <CommitteeList tpye={'S'}></CommitteeList>
                }    
                </Box>
            </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default RecentlyOrganized;